<template>
  <div class="page" style="padding-top: 66px;">
    <img class="bg-pic" src="@/assets/new/company.png" alt="" />
    <div class="content-center">
      <div class="first">
        <div class="left">
          <p>福建聚合云科技集团有限公司</p>
          <p>Fujian juheyun Technology Group Co. , Ltd.</p>
          <div class="company-img">
            <img src="@/assets/new/company_img.png" alt="" />
          </div>
          <div class="left-footer">
            <div class="footer-left">
              <p>
                用户可通过扫描右侧二维码关注“聚合云”
                “店收盈”公众号，自主查看企业信息。
              </p>
            </div>
            <div class="footer-right">
              <div>
                <img src="@/assets/new/juheyun.png" alt="" />
                <span>聚合云公众号</span>
              </div>
              <div>
                <img src="@/assets/new/dianshouying.png" alt="" />
                <span>店收盈公众号</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <p>公司简介</p>
          <div class="content">
            <p>
              聚合云集团是一家专注于“支付+”的创新型智慧场景解决方案提供商，秉承“用数字科技赋能商户经营提升”的理念，基于“支付+营销+权益+金融”的四大引擎战略，推出线下零售、停车场、加油站、物业、自助零售柜、商旅、餐饮等多款“支付+”产品及行业综合智慧场景数字平台解决方案。
            </p>
            <br />
            <p>
              十多年来，聚合云运用支付技术，发掘商家和消费者需求，通过探索支付推动各行业的创新升级，让支付变得更智慧。从支付到基于场景的智慧商圈，从传统模式到开放的综合服务平台，聚合云将始终以服务实体为本，探索与线下商业的数字化业务深度合作，构建以数字化作为驱动、运营管理更智能、体验更人性化的新型智慧商圈新生态。
            </p>
          </div>
        </div>
      </div>

      <br />
    </div>
    <div class="bbb">
      <div class="title"><span>我们的发展历程</span></div>
      <div style="height: 700px;margin-top: 20px;">
        <el-steps direction="vertical" :active="6">
          <el-step description="聚合云公司创立，成为中国首批网络整合营销服务商之一。">
            <span slot="title" style="font-size:24px;">2010年</span>
          </el-step>
          <el-step description="投资成立乡里郎公司，准入于工行建行农行等银行积分商城及扶贫商城，成为工行乡村振兴特约商家及线下采购商，获得政府电商奖励基金。">
            <span slot="title" style="font-size:24px;">2014年</span>
          </el-step>
          <el-step description="聚合云集团公司成为工行联盟商圈商户拓展服务商之一。">
            <span slot="title" style="font-size:24px;">2016年</span>
          </el-step>
          <el-step description="投资成立易联达公司，成为工行特约商户拓展服务商之一。">
            <span slot="title" style="font-size:24px;">2018年</span>
          </el-step>
          <el-step description="聚合云集团公司获中国支付清算协会外包服务商评级B级。">
            <span slot="title" style="font-size:24px;">2019年</span>
          </el-step>
          <el-step description="聚合云集团公司成为全国多个省份多家银行的特约商户拓展服务商，上线聚合云智慧支付服务系统，成功通过中国支付清算协会聚合支付技术服务类型机构备案。">
            <span slot="title" style="font-size:24px;">2023年</span>
          </el-step>
        </el-steps>
      </div>
    </div>
    <div class="aaa">
      <div class="title"><span>我们的发展历程</span></div>
      <div>
        <div class="history">
          <el-carousel
            :interval="5000"
            arrow="never"
            indicator-position="none"
            @change="change"
            :autoplay="true"
            ref="carousel"
          >
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2010年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >聚合云公司创立，成为中国首批网络整合营销服务商之一。</span
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2014年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >投资成立乡里郎公司，准入于工行建行农行等银行积分商城
                    及扶贫商城，成为工行乡村振兴特约商家及线下采购商，获得政府电商奖励基金。</span
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2016年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >聚合云集团公司成为工行联盟商圈商户拓展服务商之一。</span
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2018年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >投资成立易联达公司，成为工行特约商户拓展服务商之一。</span
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2019年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >聚合云集团公司获中国支付清算协会外包服务商评级B级。</span
                  >
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div class="container">
                <div class="title">
                  <span>2023年</span>
                </div>
                <div class="content">
                  <span>·</span>
                  <span
                    >聚合云集团公司成为全国多个省份多家银行的特约商户拓展服务商，上线聚合云智慧支付服务系统，成功通过中国支付清算协会聚合支付技术服务类型机构备案。</span
                  >
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <div class="step">
      <div class="triangle" ref="triangle"></div>
      <div class="left" @click="changeLeft"></div>
      <div class="right" @click="changeRight"></div>
      <div class="item"><span>2010年</span></div>
      <div class="item"><span>2014年</span></div>
      <div class="item"><span>2016年</span></div>
      <div class="item"><span>2018年</span></div>
      <div class="item"><span>2019年</span></div>
      <div class="item"><span>2023年</span></div>
    </div>
    <div class="company-footer">
      <div>
        <div class="top-title">企业使命</div>
        <div class="content">
          <p>构建智慧支付生态圈</p>
        </div>
        <br />
        <div class="top-title">企业愿景</div>
        <div class="content">
          <p>成为中国领先的智慧场景数字化服务商</p>
        </div>
        <br />
        <div class="top-title">企业价值观</div>
        <div class="content">
          <p>客户导向、结果负责、学习创新、团结高效</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Throttle } from "@/utils";
export default {
  name: "CompanyProfile",
  data() {
    return {
      pIndex: 0,
    };
  },
  methods: {
    changeLeft: Throttle(function () {
      this.$refs.carousel.prev();
    }, 500),
    changeRight: Throttle(function () {
      this.$refs.carousel.next();
    }, 500),
    TurnLeft(index) {
      const slider = this.$refs.triangle;
      let currentPosition = slider.offsetLeft;
      if (index === 0 && this.pIndex === 5) {
        slider.style.left = 88.5 + "px";
        return;
      }
      const speed = 1;
      const moveLeft = setInterval(() => {
        currentPosition -= speed;
        slider.style.left = currentPosition + "px";
        if (currentPosition <= index * 217 + 88.5) {
          clearInterval(moveLeft);
        }
      }, 3);
    },
    TurnRight(index) {
      const slider = this.$refs.triangle;
      let currentPosition = slider.offsetLeft;
      if (index === 5 && this.pIndex === 0) {
        slider.style.left = 217 * 5 + 88.5 + "px";
        return;
      }
      const speed = 1;
      const moveRight = setInterval(() => {
        currentPosition += speed;
        slider.style.left = currentPosition + "px";
        if (currentPosition >= index * 217 + 88.5) {
          clearInterval(moveRight);
        }
      }, 3);
    },
    change(e) {
      if (e > this.pIndex) {
        this.TurnRight(e, this.pIndex);
      } else {
        this.TurnLeft(e, this.pIndex);
      }
      this.pIndex = e;
    },
  },
};
</script>

<style lang="scss" scoped>
.triangle {
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  left: 88.5px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 40px solid #ea0000;
}
.step {
  margin: 0 auto;
  padding: 30px 0;
  width: 1302px;
  position: relative;
  display: flex;
  height: 200px;
  border-top: 2px solid #e9ecf3;
  padding-top: 50px;
  .item {
    color: #707172;
    width: 217px;
    text-align: center;
  }
  .left {
    position: absolute;
    left: -25px;
    top: -25px;
    width: 60px;
    height: 60px;
    cursor: pointer;
    background: url(../assets/new/left_white.png) no-repeat center;
    background-size: 100% 100%;
  }
  .left:hover {
    background: url(../assets/new/left_red.png) no-repeat center;
    background-size: 100% 100%;
  }
  .right {
    position: absolute;
    right: -25px;
    top: -25px;
    width: 60px;
    height: 60px;
    cursor: pointer;
    background: url(../assets/new/right_white.png) no-repeat center;
    background-size: 100% 100%;
  }
  .right:hover {
    background: url(../assets/new/right_red.png) no-repeat center;
    background-size: 100% 100%;
  }
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
h3 {
  font-weight: normal;
}
.page {
  .bg-pic {
    width: 100%;
  }
}
.bottom-content {
  margin: 0px 100px;
  width: 89%;
  border-radius: 10px;
  background: #fff;
  padding: 50px 68px 56px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  .top-title {
    margin-bottom: 20px;
    color: #ffc106;
  }
  .content {
    font-size: 14px;
    color: #666;
  }
}
.content-center {
  padding: 30px 0;
  width: 1160px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .first {
    display: flex;
    justify-content: space-between;
    .left {
      width: 540px;
      font-size: 20px;
      p:nth-of-type(1) {
        color: #333;
        font-size: 36px;
        height: 50px;
      }
      p:nth-of-type(2) {
        color: #707172;
        font-size: 20px;
        height: 30px;
      }
      .company-img {
        margin-top: 20px;
        width: 100%;
        img {
          width: 100%;
        }
      }
      .left-footer {
        background-color: #de1f26;
        display: flex;
        padding-right: 20px;
        padding: 20px;
        margin-top: 10px;
        .footer-left {
          width: 60%;
          display: flex;
          align-items: center;
          p {
            color: #fff;
            font-size: 14px;
          }
        }
        .footer-right {
          display: flex;
          justify-content: space-around;
          width: 40%;
          div {
            display: flex;
            flex-direction: column;
            justify-content: center;
            font-size: 12px;
            color: #fff;
            text-align: center;
            padding: 5px;
            border: 1px solid #fff;
            img {
              width: 86px;
              height: 86px;
            }
          }
        }
      }
    }
    .right {
      width: 580px;
      > p {
        font-size: 24px;
        height: 30px;
        color: #333;
      }
      .content {
        font-size: 20px;
        margin-top: 35px;
        border-top: 2px solid #d9d9d9;
        padding-top: 33px;
        color: #707172;
        line-height: 30px;
      }
    }
  }
}
.company-footer {
  color: #fff;
  height: 400px;
  padding: 30px 0;
  width: 100%;
  margin: 0 auto;
  background: url(../assets/new/company_footer.png);
  background-size: 100% 100%;
  > div {
    width: 1160px;
    margin: 0 auto;
    .top-title {
      font-size: 40px;
    }
    .content {
      font-size: 24px;
    }
  }
}
@media screen and (max-width: 768px) {
  .aaa,
  .step {
    display: none !important;
  }
  // .bbb {
  //   display: block !important;
  // }
}

/* ========== PC端：只显示 aaa 和 step，隐藏 bbb ========== */
@media screen and (min-width: 769px) {
  // .aaa,
  // .step {
  //   display: block !important;
  // }
  .bbb {
    display: none !important;
  }
}
.bbb{
  padding: 30px;
  .title {
    font-size: 30px;
    text-align: center;
  }
  ::v-deep .el-step__icon{
    width: 20px;
    height: 20px;
    background-color: #409eff;
  }
  ::v-deep .el-step__line{
    top: 22% !important;
    left: 9px;
  }
  // .step-icon{
  //   width: 100%;
  //   height: 100%;
  //   background-color: #409eff;
  //   border-radius: 50%;
  //   border: 1px solid #409eff;
  // }
}
.aaa {
  background-color: #f9fafc;
  padding: 30px 0;
  .title {
    font-size: 40px;
    text-align: center;
  }
  div:nth-of-type(2) {
    background: url(../assets/new/company_banner.png);
    background-size: 100% 100%;
    width: 1160px;
    height: 640px;
    margin: 0 auto;
  }
}
::v-deep .el-carousel__container {
  width: 1160px;
  height: 100% !important;
}
.history {
  height: 100%;
  .el-carousel {
    height: 100%;
  }
  .container {
    display: flex;
    align-items: center;
    height: 100%;
    .title {
      font-size: 128px;
      width: 40%;
    }
    .content {
      width: 60%;
      height: 50px;
      display: flex;
      span:nth-of-type(1) {
        font-size: 40px;
        line-height: 40px;
        color: #de1f26;
      }
      span:nth-of-type(2) {
        margin-left: 20px;
        font-size: 20px;
        line-height: 40px;
        color: #333;
      }
    }
  }
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
}

.el-carousel__item:nth-child(2n + 1) {
}


/* ========== 新增移动端适配 只加这里，不改动原有样式 ========== */
@media screen and (max-width: 768px) {
  .content-center{
    width: 95% !important;
  }
  .content-center .first{
    flex-direction: column;
  }
  .content-center .first .left,
  .content-center .first .right{
    width: 100% !important;
  }
  .content-center .first .left p:nth-of-type(1){
    font-size: 22px !important;
    height: auto !important;
  }
  .content-center .first .left p:nth-of-type(2){
    font-size: 14px !important;
    height: auto !important;
  }
  .content-center .first .left .left-footer{
    flex-direction: column;
    gap:15px;
  }
  .content-center .first .left .left-footer .footer-left,
  .content-center .first .left .left-footer .footer-right{
    width: 100% !important;
  }

  .aaa div:nth-of-type(2){
    width: 95% !important;
    height: auto !important;
    padding:40px 0;
  }
  ::v-deep .el-carousel__container{
    width: 100% !important;
  }
  .history .container{
    flex-direction: column;
    text-align:center;
  }
  .history .container .title{
    width:100% !important;
    font-size: 60px !important;
  }
  .history .container .content{
    width:100% !important;
    margin-top:20px;
  }
  .history .container .content span:nth-of-type(2){
    margin-left:0 !important;
    font-size:16px !important;
    line-height:1.8 !important;
  }

  .step{
    width: 100% !important;
    overflow-x: auto;
  }
  .step .item{
    width: auto !important;
    min-width:100px;
  }
  .step .left,.step .right,.step .triangle{
    display: none !important;
  }

  .company-footer > div{
    width: 95% !important;
  }
  .company-footer .top-title{
    font-size:24px !important;
  }
  .company-footer .content{
    font-size:16px !important;
  }

  .aaa .title{
    font-size:24px !important;
  }
}
</style>
